import React, { createContext } from 'react';

import { RENDER_TYPE_LIST } from '@/common/constants';
import {
  ProductsTableContextDefaultProps,
  ProductsTableContextPropTypes,
} from '@/ebat/components/blocks/Products/ProductsTableContext/ProductsTableContext.proptypes';
import useTableRowSize from '@/ebat/components/blocks/Products/ProductsTableContext/useTableRowSize';

export const ProductsTableContext = createContext({});

const ProductTableProvider = ({ children, renderType, tableContainerRef }) => {
  const isTableRow = renderType === RENDER_TYPE_LIST;
  const { containerRef, tableRowSize } = useTableRowSize(
    isTableRow,
    tableContainerRef,
  );

  return (
    <ProductsTableContext.Provider
      value={{
        containerRef,
        isTableRow,
        tableRowSize,
      }}
    >
      {children}
    </ProductsTableContext.Provider>
  );
};

ProductTableProvider.defaultProps = {
  ...ProductsTableContextDefaultProps,
};

ProductTableProvider.propTypes = {
  ...ProductsTableContextPropTypes,
};

export default ProductTableProvider;
